import { render, staticRenderFns } from "./PropertyFormBilling.vue?vue&type=template&id=60a9a9d9&scoped=true&"
import script from "./PropertyFormBilling.vue?vue&type=script&lang=js&"
export * from "./PropertyFormBilling.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFormBilling.vue?vue&type=style&index=0&id=60a9a9d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9a9d9",
  null
  
)

export default component.exports